export enum ExportTypeEnum {
    Zip = 1,
    JSON = 2,
    GEOJSON = 3,
    SHP = 4,
    GEOPACKAGE = 5,
    RENNS = 6,
    DXF = 7
}

